/** Fetch wrappers around the backend API. */

async function jsonOrThrow(res) {
  let body = null;
  try { body = await res.json(); } catch { /* ignore */ }
  if(!res.ok)
    throw new Error(body?.error || `HTTP ${res.status}`);
  return body;
}

export async function getSession() {
  const res = await fetch("/api/session");
  return jsonOrThrow(res);
}

export async function login(user, password) {
  const res = await fetch("/api/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ user, password }),
  });
  return jsonOrThrow(res);
}

export async function logout() {
  await fetch("/api/logout", { method: "POST" });
}

/** POST /api/regenerate and invoke `onEvent` for each NDJSON line. */
export async function regenerate(onEvent) {
  const res = await fetch("/api/regenerate", { method: "POST" });
  if(!res.ok && !res.body) {
    const body = await res.json().catch(() => null);
    throw new Error(body?.error || `HTTP ${res.status}`);
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  const flush = (chunk) => {
    buf += chunk;
    let idx;
    while((idx = buf.indexOf("\n")) >= 0) {
      const line = buf.slice(0, idx).trim();
      buf = buf.slice(idx + 1);
      if(line) onEvent(JSON.parse(line));
    }
  };
  for(;;) {
    const { done, value } = await reader.read();
    if(done) break;
    flush(decoder.decode(value, { stream: true }));
  }
  const rest = buf.trim();
  if(rest) onEvent(JSON.parse(rest));
}

export async function getImages() {
  const res = await fetch("/api/images");
  return jsonOrThrow(res);
}

/** Upload a File as `filename` (a safe basename with extension). */
export async function uploadImage(filename, file) {
  const res = await fetch(`/api/images/upload?filename=${encodeURIComponent(filename)}`, {
    method: "POST",
    headers: { "Content-Type": file.type || "application/octet-stream" },
    body: file,
  });
  return jsonOrThrow(res);
}

/** Same-origin URL that proxies a Google My Maps photo (bypasses CORS). */
export function proxyImageUrl(url) {
  return `/api/images/proxy?url=${encodeURIComponent(url)}`;
}

/** Download a salon's Google My Maps photo and store it on SFTP as its image. */
export async function useGoogleImage({ url, filename, slug }) {
  const res = await fetch("/api/images/from-maps", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ url, filename, slug }),
  });
  return jsonOrThrow(res);
}
